package com.anjuros.website.templates.template9.sections

import com.anjuros.website.templates.template9.components.Template9Reveal
import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template9.components.Template9Eyebrow
import com.anjuros.website.templates.template9.components.Template9IconBadge
import com.anjuros.website.templates.template9.components.Template9Squiggle
import com.anjuros.website.templates.template9.components.Template9Wave
import com.anjuros.website.templates.template9.modules.Template9AboutFeature
import com.anjuros.website.templates.template9.modules.Template9Section
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.getColorHex
import com.anjuros.website.templates.template9.styles.TEMPLATE9_BLOB_ABOUT
import com.anjuros.website.templates.template9.styles.Template9AboutImageBoxStyle
import com.anjuros.website.templates.template9.styles.Template9AboutSmallImageStyle
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9SectionTitleStyle
import com.anjuros.website.templates.template9.styles.Template9WaveStyle
import com.anjuros.website.templates.template9.styles.template9Blob
import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Constants
import com.anjuros.website.templates.template9.util.Template9Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template9AboutSection() {
    Column(
        modifier = Modifier
            .id(Template9Section.AboutMe.id)
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Background.rgb),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Template9Wave(
            modifier = Template9WaveStyle.toModifier(),
            color = Template9Theme.Cream.hex,
            top = true
        )
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Template9Theme.Cream.rgb)
                .padding(topBottom = 40.px),
            contentAlignment = Alignment.Center
        ) {
            Image(
                modifier = Modifier
                    .displayIfAtLeast(Breakpoint.LG)
                    .align(Alignment.CenterEnd)
                    .size(140.px)
                    .margin(right = 40.px)
                    .opacity(0.5f),
                src = Template9Res.Icon.paw_watermark,
                alt = ""
            )
            SimpleGrid(
                numColumns = numColumns(base = 1, lg = 2),
                modifier = Template9ContainerStyle.toModifier()
                    .gap(50.px)
            ) {
                Template9Reveal(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    Template9AboutImages()
                }
                Template9Reveal(
                    modifier = Modifier.styleModifier { property("align-self", "center") },
                    delayMs = 150
                ) {
                    Column {
                        Template9AboutText()
                    }
                }
            }
        }
        Template9Wave(
            modifier = Template9WaveStyle.toModifier(),
            color = Template9Theme.Cream.hex,
            top = false
        )
    }
}

@Composable
private fun Template9AboutImages() {
    Box(
        modifier = Template9AboutImageBoxStyle.toModifier()
    ) {
        // big organic photo
        Box(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .styleModifier {
                    property("width", "86%")
                    property("height", "92%")
                }
                .template9Blob(TEMPLATE9_BLOB_ABOUT)
                .overflow(Overflow.Hidden)
                .boxShadow(offsetY = 16.px, blurRadius = 36.px, color = rgba(27, 33, 66, 0.15))
        ) {
            AnjurosImage(
                modifier = Modifier
                    .fillMaxSize()
                    .objectFit(ObjectFit.Cover),
                src = Template9Res.Image.about_main,
                alt = "Dog walker with a happy dog on a countryside walk"
            )
        }
        // small round photo
        AnjurosImage(
            modifier = Template9AboutSmallImageStyle.toModifier()
                .align(Alignment.BottomStart)
                .borderRadius(50.percent)
                .objectFit(ObjectFit.Cover)
                .border(width = 6.px, style = LineStyle.Solid, color = Colors.White)
                .boxShadow(offsetY = 10.px, blurRadius = 24.px, color = rgba(27, 33, 66, 0.18)),
            src = Template9Res.Image.about_small,
            alt = "Happy dog looking at the camera"
        )
        // yellow paw badge
        Template9IconBadge(
            modifier = Modifier
                .align(Alignment.TopStart)
                .margin(top = 20.px),
            icon = Template9Res.Icon.paw_white,
            alt = "paw",
            accent = true,
            size = 76,
            iconSize = 36
        )
    }
}

@Composable
private fun Template9AboutText() {

    Template9Eyebrow(text = ResKey.TEMPLATE9_ABOUT_EYEBROW)

    P(
        attrs = Template9SectionTitleStyle.toModifier()
            .maxWidth(440.px)
            .margin(top = 14.px, bottom = 6.px)
            .fontFamily(Template9Constants.HEADING_FONT_FAMILY, Template9Constants.FONT_FAMILY)
            .fontWeight(FontWeight.Bold)
            .color(Template9Theme.Secondary.rgb)
            .toAttrs()
    ) {
        Text(LocalText(ResKey.TEMPLATE9_ABOUT_TITLE))
    }
    Template9Squiggle(color = Template9Theme.Primary.getColorHex())

    P(
        attrs = Modifier
            .maxWidth(460.px)
            .margin(top = 20.px, bottom = 26.px)
            .fontFamily(Template9Constants.FONT_FAMILY)
            .fontSize(16.px)
            .lineHeight(1.7)
            .color(Template9Theme.Text.rgb)
            .toAttrs()
    ) {
        Text(LocalText(ResKey.TEMPLATE9_ABOUT_PARAGRAPH))
    }

    Column(modifier = Modifier.gap(18.px)) {
        Template9AboutFeature.entries.forEach { feature ->
            Row(
                modifier = Modifier.gap(16.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Template9IconBadge(
                    modifier = Modifier.flexShrink(0),
                    icon = feature.icon,
                    alt = "dog walker values",
                    size = 50,
                    iconSize = 24
                )
                Column {
                    P(
                        attrs = Modifier
                            .margin(0.px)
                            .fontFamily(Template9Constants.FONT_FAMILY)
                            .fontSize(15.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Template9Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(feature.title))
                    }
                    P(
                        attrs = Modifier
                            .margin(top = 3.px, bottom = 0.px)
                            .fontFamily(Template9Constants.FONT_FAMILY)
                            .fontSize(13.px)
                            .color(Template9Theme.Text.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(feature.description))
                    }
                }
            }
        }
    }
}
